import { FeaturedAgentType } from '@propertypal/shared/src/types/agents';
import { SearchParams } from '@propertypal/shared/src/types/search';
import { Filters } from '@propertypal/shared/src/utils/search/getNlpFilters';
import React, { FunctionComponent, useEffect, useState } from 'react';
import HomeSearchBar from '../search/HomeSearchBar';
import { Container, Content, SubTitle, TabBar, TabItem, Title } from './SearchAgents.style';

interface Props {
  onSubmit: (params: string) => void;
  searchParams?: SearchParams;
  tall?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  featuredAgent?: FeaturedAgentType;
}

const SEARCH_TABS = [
  {
    label: 'Sales',
    category: 'residential',
    saleType: 'sale',
  },
  {
    label: 'Rentals',
    category: 'residential',
    saleType: 'rent',
  },
  {
    label: 'Student Rentals',
    category: 'student',
    saleType: 'rent',
  },
  {
    label: 'Commercial',
    category: 'commercial',
    saleType: 'sale',
  },
  {
    label: 'New Homes',
    category: 'newhomes',
    saleType: 'sale',
  },
];

const getInitialTab = (params?: SearchParams) => {
  const initialTab = SEARCH_TABS.find((tab) => {
    return (
      params?.saleType && tab.saleType === params.saleType[0] && params.category && tab.category === params.category[0]
    );
  });

  return initialTab?.label || SEARCH_TABS[0].label;
};

const SearchAgents: FunctionComponent<Props> = (props) => {
  const [activeTab, setActiveTab] = useState<string>(() => getInitialTab(props.searchParams));

  const onTabClick = (label: string) => {
    setActiveTab(label);

    const input = document.querySelector<HTMLInputElement>('[data-testid="searchInput"]');
    const tab = SEARCH_TABS.find((t) => t.label === label);

    if (tab && input && props.onSubmit) {
      props.onSubmit(`q=${encodeURIComponent(input.value)}&pt=${tab.category}&st=${tab.saleType}`);
    }
  };

  const handleSubmit = (_: string, text: string, filters: Filters) => {
    const tab = SEARCH_TABS.find((t) => t.label === activeTab);

    if (tab) {
      const location = filters.lat && filters.lng ? `&lat=${filters.lat}&lng=${filters.lng}&radius=5` : '';
      props.onSubmit(`q=${encodeURIComponent(text)}&pt=${tab.category}&st=${tab.saleType}${location}`);
    }
  };

  useEffect(() => {
    setActiveTab(getInitialTab(props.searchParams));
  }, [props.searchParams]);

  useEffect(() => {
    const index = SEARCH_TABS.findIndex((t) => t.label === activeTab);
    const el = document.getElementById(`search-tab-${index}`);

    if (el) {
      el.scrollIntoView(false);
    }
  }, []);

  return (
    <Container $tall={props.tall}>
      <Content>
        {props.tall && (
          <>
            <Title>Find your local Estate Agent</Title>
            <SubTitle>
              Whether buying, selling, renting or letting start your search here to find the right local expert for you.
            </SubTitle>
          </>
        )}

        <TabBar>
          {SEARCH_TABS.map((tab, index) => (
            <TabItem
              $active={activeTab === tab.label}
              key={tab.label}
              onClick={() => onTabClick(tab.label)}
              id={`search-tab-${index}`}
            >
              {tab.label}
            </TabItem>
          ))}
        </TabBar>

        <HomeSearchBar
          containerStyle={{ margin: '15px auto 0' }}
          submitText="Find agents"
          onSubmit={handleSubmit}
          extraNlpParams="termTypes=ACCOUNT%2CACCOUNT_GROUP%2CTOWN%2CAREA&addressSuggestions=false"
          placeholder="Postcode, town, area or agent"
        />
      </Content>
    </Container>
  );
};

export default SearchAgents;
